import React from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { withRouter, RouteComponentProps } from "react-router";

import { RootState } from "../store/modules";

import AdSetList from "./AdSetListContainer";
import AdCampaignDetailContainer from "./AdCampaign/AdCampaignDetailContainer";
import AdSetDetailContainer from "./AdSet/AdSetDetailContainer";

type Props = ReturnType<typeof mapStateToProps> & RouteComponentProps;

class AdCampaignSummaryContainer extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  // jsx
  // -----------------------------------------------

  public render() {
    if (!this.props.match) {
      return null;
    }
    const { params } = this.props.match;
    const adCampaignId = params["ad_campaign_id"];

    return (
      <Container>
        <AdSetList />
        {!!this.props.focusedAdSetId ||
        this.props.match.path ===
          "/admin/ad/ad_accounts/:ad_account_id/ad_campaigns/:ad_campaign_id/ad_sets/new" ? (
          <AdSetDetailContainer adSetId={this.props.focusedAdSetId} />
        ) : (
          <AdCampaignDetailContainer adCampaignId={adCampaignId} />
        )}
      </Container>
    );
  }
}

// connect
// -----------------------------------------------

function mapStateToProps(state: RootState) {
  const { focusedAdSetId } = state.ui.adCampaignSummary;
  return { focusedAdSetId };
}

export default withRouter(connect(mapStateToProps)(AdCampaignSummaryContainer));

const Container = styled.div`
  display: flex;
`;
